/* ==========================================================================
   FX HOME — portado desde el prototipo aprobado
   C:\Shopify\hero-anterior-original\prototype-future-store\app.js
   Módulos copiados: headerModule, navHighlightModule, clockModule,
   createParticleField, globeSphereModule. Selectores adaptados a fx-*.
   NO incluye: CartModule/localStorage, filtros de tarjetas simuladas,
   checkout falso — esa lógica se reemplaza por Shopify real.
   ========================================================================== */
(function () {
  "use strict";

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let isTabVisible = !document.hidden;
  document.addEventListener("visibilitychange", () => {
    isTabVisible = !document.hidden;
  });

  /* ------------------------------------------------------------------
     1. HEADER: transform on scroll + mobile menu
  ------------------------------------------------------------------ */
  (function headerModule() {
    const header = document.getElementById("fx-site-header");
    const toggle = document.getElementById("fx-mobile-menu-toggle");
    const mobileNav = document.getElementById("fx-mobile-nav");

    if (!header) return;

    const scrollSource = document.querySelector(".page-wrapper") || window;
    const getScrollTop = () =>
      scrollSource === window ? window.scrollY : scrollSource.scrollTop;

    let ticking = false;

    function onScroll() {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(() => {
        header.classList.toggle("fx-is-scrolled", getScrollTop() > 40);
        ticking = false;
      });
    }

    scrollSource.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    if (toggle && mobileNav) {
      toggle.addEventListener("click", () => {
        const isOpen = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!isOpen));
        toggle.setAttribute("aria-label", isOpen ? "Abrir menú" : "Cerrar menú");
        mobileNav.setAttribute("data-open", String(!isOpen));
      });

      mobileNav.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", () => {
          toggle.setAttribute("aria-expanded", "false");
          toggle.setAttribute("aria-label", "Abrir menú");
          mobileNav.setAttribute("data-open", "false");
        });
      });
    }
  })();

  /* ------------------------------------------------------------------
     2. ACTIVE NAV LINK ON SCROLL
  ------------------------------------------------------------------ */
  (function navHighlightModule() {
    const sectionIds = ["fx-hero", "fx-categorias", "fx-productos", "fx-future-os", "fx-contacto"];
    const sections = sectionIds.map((id) => document.getElementById(id)).filter(Boolean);
    const navLinks = document.querySelectorAll(".fx-main-nav a");
    if (!sections.length || !navLinks.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const id = entry.target.id;
        navLinks.forEach((link) => {
          const href = link.getAttribute("href") || "";
          const matches = href === `#${id}` || href.endsWith(`#${id}`);
          link.classList.toggle("fx-is-active", matches);
        });
      });
    }, { rootMargin: "-40% 0px -50% 0px" });

    sections.forEach((s) => observer.observe(s));
  })();

  /* ------------------------------------------------------------------
     3. FUTURE OS CLOCK
  ------------------------------------------------------------------ */
  (function clockModule() {
    const timeEl = document.getElementById("fx-os-clock-time");
    const dateEl = document.getElementById("fx-os-clock-date");
    if (!timeEl) return;
    function tick() {
      const now = new Date();
      timeEl.textContent = now.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit", hour12: true });
      if (dateEl) dateEl.textContent = now.toLocaleDateString("es-MX", { day: "2-digit", month: "2-digit", year: "numeric" });
    }
    tick();
    setInterval(tick, 1000 * 30);
  })();

  /* ------------------------------------------------------------------
     4. PARTICLES (hero) — canvas, rAF, pausable
  ------------------------------------------------------------------ */
  function createParticleField(canvas, options) {
    if (!canvas) return null;
    const ctx = canvas.getContext("2d");
    const opts = Object.assign({
      density: 60,
      areaPerParticle: 16000,
      color: "0,229,255",
      speed: 0.25,
      convergeX: 0.5,
      convergeY: 0.5,
      twinkleRatio: 0.4,
    }, options || {});

    let width, height, particles, rafId, running = true;
    let convergeProgress = 0;
    let convergeTarget = 0;
    let clock = 0;

    function resize() {
      const rect = canvas.parentElement.getBoundingClientRect();
      width = canvas.width = rect.width * window.devicePixelRatio;
      height = canvas.height = rect.height * window.devicePixelRatio;
      canvas.style.width = rect.width + "px";
      canvas.style.height = rect.height + "px";
      initParticles();
    }

    function initParticles() {
      const count = prefersReducedMotion ? 0 : Math.round((width * height) / (opts.areaPerParticle * (window.innerWidth < 720 ? 2.2 : 1)));
      particles = new Array(Math.min(count, opts.density)).fill(0).map(() => {
        const depth = Math.random();
        const twinkle = Math.random() < opts.twinkleRatio;
        return {
          x: Math.random() * width,
          y: Math.random() * height,
          vx: (Math.random() - 0.5) * opts.speed * (0.35 + depth * 0.9),
          vy: (Math.random() - 0.5) * opts.speed * (0.35 + depth * 0.9),
          r: 0.5 + depth * 1.9,
          baseAlpha: 0.22 + depth * 0.55,
          twinkle,
          twinklePhase: Math.random() * Math.PI * 2,
          twinkleSpeed: 0.5 + Math.random() * 1.1,
        };
      });
    }

    function draw() {
      ctx.clearRect(0, 0, width, height);
      clock += 0.016;
      const cx = width * opts.convergeX, cy = height * opts.convergeY;
      particles.forEach((p) => {
        if (convergeTarget) {
          p.x += (cx - p.x) * 0.012 * convergeProgress;
          p.y += (cy - p.y) * 0.012 * convergeProgress;
        } else {
          p.x += p.vx;
          p.y += p.vy;
          if (p.x < 0 || p.x > width) p.vx *= -1;
          if (p.y < 0 || p.y > height) p.vy *= -1;
        }
        const alpha = p.twinkle
          ? p.baseAlpha * (0.5 + 0.5 * Math.sin(clock * p.twinkleSpeed + p.twinklePhase))
          : p.baseAlpha;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${opts.color},${alpha.toFixed(3)})`;
        ctx.fill();
      });
      if (convergeTarget && convergeProgress < 1) convergeProgress += 0.02;
    }

    function loop() {
      if (!running || !isTabVisible) {
        rafId = requestAnimationFrame(loop);
        return;
      }
      draw();
      rafId = requestAnimationFrame(loop);
    }

    resize();
    window.addEventListener("resize", resize, { passive: true });
    if (!prefersReducedMotion) {
      rafId = requestAnimationFrame(loop);
    } else {
      draw();
    }

    return {
      converge() { convergeTarget = 1; convergeProgress = 0; },
      release() { convergeTarget = 0; },
      pause() { running = false; },
      resume() { running = true; },
    };
  }

  createParticleField(document.getElementById("fx-particles-canvas"), {
    density: 170, areaPerParticle: 8000, color: "0,229,255", speed: 0.16, convergeX: 0.5, convergeY: 0.62,
  });

  /* ------------------------------------------------------------------
     5. HOLOGRAPHIC SPHERE (globo rotatorio independiente)
     Requiere data-earth-texture en #fx-globe-stage (URL vía asset_url,
     inyectada desde Liquid porque este archivo es un asset estático).
  ------------------------------------------------------------------ */
  (function globeSphereModule() {
    const stage = document.getElementById("fx-globe-stage");
    const canvas = document.getElementById("fx-globe-canvas");
    if (!stage || !canvas) return null;
    const ctx = canvas.getContext("2d");

    const ROTATION_SECONDS = 40;
    const CLOUD_ROTATION_SECONDS = 26;
    const FPS_ASSUMED = 60;

    let width = 0, height = 0, cloudTileW = 0;
    let cloudTile = null;
    let surfaceOffset = 0, cloudOffset = 0;
    let running = true;
    let rafId = null;
    let earthReady = false;

    const earthImage = new Image();
    earthImage.src = stage.getAttribute("data-earth-texture") || "";
    earthImage.onload = () => { earthReady = true; draw(); };

    function mulberry32(seed) {
      return function () {
        seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
        let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      };
    }

    function buildCloudTile() {
      cloudTileW = Math.max(1, Math.round(width));
      const tileH = Math.max(1, Math.round(height));
      cloudTile = document.createElement("canvas");
      cloudTile.width = cloudTileW;
      cloudTile.height = tileH;
      const cctx = cloudTile.getContext("2d");
      const rand = mulberry32(20260729);
      cctx.fillStyle = "rgba(255,255,255,0.16)";
      const cloudCount = 5;
      for (let i = 0; i < cloudCount; i++) {
        const bx = rand() * cloudTileW;
        const by = tileH * 0.1 + rand() * tileH * 0.8;
        const bw = cloudTileW * (0.16 + rand() * 0.2);
        const bh = tileH * (0.05 + rand() * 0.09);
        cctx.beginPath();
        cctx.ellipse(bx, by, bw / 2, bh / 2, 0, 0, Math.PI * 2);
        cctx.fill();
      }
    }

    function resize() {
      const rect = stage.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;
      width = canvas.width = Math.max(1, Math.round(rect.width * dpr));
      height = canvas.height = Math.max(1, Math.round(rect.height * dpr));
      canvas.style.width = rect.width + "px";
      canvas.style.height = rect.height + "px";
      buildCloudTile();
    }

    function draw() {
      ctx.clearRect(0, 0, width, height);

      if (earthReady) {
        const loopW = height * (earthImage.naturalWidth / earthImage.naturalHeight);
        const sx = -(surfaceOffset % loopW);
        ctx.drawImage(earthImage, sx, 0, loopW, height);
        ctx.drawImage(earthImage, sx + loopW, 0, loopW, height);
      }

      if (cloudTile) {
        const cx = -(cloudOffset % cloudTileW);
        ctx.drawImage(cloudTile, cx, 0, cloudTileW, height);
        ctx.drawImage(cloudTile, cx + cloudTileW, 0, cloudTileW, height);
      }
    }

    function loop() {
      if (running && isTabVisible) {
        const loopW = earthReady ? height * (earthImage.naturalWidth / earthImage.naturalHeight) : width;
        surfaceOffset += loopW / (ROTATION_SECONDS * FPS_ASSUMED);
        cloudOffset += cloudTileW / (CLOUD_ROTATION_SECONDS * FPS_ASSUMED);
        draw();
      }
      rafId = requestAnimationFrame(loop);
    }

    resize();
    window.addEventListener("resize", resize, { passive: true });

    if (prefersReducedMotion) {
      draw();
    } else {
      rafId = requestAnimationFrame(loop);
    }

    return {
      pause() { running = false; },
      resume() { running = true; },
    };
  })();
})();
